import React, { useState, useContext, useEffect } from 'react'
import { Label, Select, SelectOption, Alert } from '@americanexpress/dls-react'
import UserContext from '../ContextComponent/UserContext'

function ResidentStatus() {
    const { formData, setFormData } = useContext(UserContext);
    const { errorData, setErrorData } = useContext(UserContext);
    const [options, setOptions] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            const result = await fetch(`/api/content/ResidentStatus`)
                .then(response => response.json())
                .then(json => json);
            setOptions(() => result.map(option => <SelectOption id={option.id} value={option.value}>{option.label}</SelectOption>))
        }
        fetchData();
    }, []);
    const onChangeHandle = (event) => {
        if (event.target.value === '') {
            setErrorData({ ...errorData, residenceStatusRequired: true });
        }
        else {
            setErrorData({ ...errorData, residenceStatusRequired: false });
        }

        setFormData({ ...formData, residentStatusCode: event.target.value });
    };

    return (
        <div>
            <Label htmlFor="residentialStatus" className="label-1">Resident Status</Label>
            <Select id="residentialStatus" value={formData.residentStatusCode} fluid={true} name="ResidenceStatus" aria-describedby="ResidenceStatus-alert" 
            onChange={onChangeHandle}>
                {options}
            </Select>
            <Alert id="ResidenceStatus-alert" show={errorData.residenceStatusRequired}>Please select a Resident status.</Alert>
        </div>
    );
}

export default ResidentStatus